// @flow
import { useHistory, useParams } from 'react-router-dom';
import React from 'react';
import { getLinkForStreamingProjectsSPPage } from '@streaming-projects/links';
import { useDeleteClusterWorkloadMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { toastError, toastSuccess } from '@presentational/notifications/utils';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';

export const SPClusterWorkloadDeleteWarningModal = ({
  isOpen,
  onClose,
  clusterWorkloadName,
  clusterWorkloadId,
  clusterWorkloadResourceId,
  spVersion,
}) => {
  const [deleteClusterWorkload] = useDeleteClusterWorkloadMutation();
  const { orgId, spId } = useParams();
  const { push } = useHistory();
  const header = `Delete Cluster Workload ${clusterWorkloadName}`;
  const headerBody = <p>Are you sure you want to delete this Cluster Workload?</p>;

  const onClickHandlerForOK = async () => {
    const { error } = await deleteClusterWorkload({
      orgId,
      spId,
      clusterWorkloadId,
      payload: {
        cluster_resource_id: clusterWorkloadResourceId,
        sp_version: spVersion,
      },
    });
    if (error) {
      toastError(error);
    } else {
      toastSuccess('Cluster Workload delete was successful!');
      push(getLinkForStreamingProjectsSPPage(orgId, spId));
    }
  };

  return (
    <ConfirmModal
      body={headerBody}
      header={header}
      isOpen={isOpen}
      onClickHandlerForCancel={onClose}
      onClickHandlerForOK={onClickHandlerForOK}
    />
  );
};
